import * as actionType from "./action";

/* YardSight-specific Reducers */
export function ymsDeckingOptTesterReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.YMS_DECKING_OPTIMIZATION_TESTER_SUCCESS:
      return { ...state, response };
    case actionType.YMS_DECKING_OPTIMIZATION_TESTER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function ymsDeckingFilterReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.YMS_DECKING_FILTER_SUCCESS:
      return { ...state, response };
    case actionType.YMS_DECKING_FILTER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
